import Menu from './Menu.js'

export default {
  Menu
}



// WEBPACK FOOTER //
// ./src/components/menus/index.js